import { useMatches } from "react-router";
import AdSettings from "@components/Advertisement/AdSettings";
import GAData from "@components/GAData/GAData";
import { getLoaderData } from "@helpers/getLoaderData";
import { HttpStatusCode } from "axios";

const ConfigurationSettings = (): React.ReactElement => {
  const matches = useMatches();
  const currentMatch = matches[matches.length - 1];
  const loaderData = getLoaderData(currentMatch);

  if (loaderData && loaderData.statusCode !== HttpStatusCode.Ok) return <></>;
  if (typeof loaderData?.payload === "undefined") return <></>;
  if (typeof loaderData?.payload === "string") return <></>;

  const adSettings = loaderData.payload.adSettings;
  const gaProps = loaderData.payload.gaProps;

  return (
    <>
      {/* Render AdSettings if route provides configuration */}
      {adSettings ? <AdSettings {...adSettings} /> : null}

      {/* Render GAData if route provides configuration */}
      {gaProps ? <GAData {...gaProps} /> : null}
    </>
  );
};

export default ConfigurationSettings;
